import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconMagicWandStyle0 = cosmosIconCss;

const CosmosIconMagicWand$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMagicWand extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ef17eed0bfc4b7039c6e74e57196f799c31b5cc8', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7546ba55a766ad5738630d8cd00dc95d96928045', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '2085d674e36ee63460deca6632aaded5e0df1a6a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.65 4c-1.667 0-3-1.333-3-3 0 1.667-1.333 3-3 3 1.667 0 3 1.334 3 3 0-1.666 1.333-3 3-3Zm.05 2c0 1.112.889 2 2 2-1.111 0-2 .89-2 2 0-1.11-.889-2-2-2 1.111 0 2-.888 2-2Zm-7.195 4.59.707.708L14.51 9l-.707-.707-2.297 2.297Zm2.65-3.357a.5.5 0 0 0-.707 0l-3.004 3.004-.008.008-.01.01a.444.444 0 0 0-.017.017l-7.964 7.965a.5.5 0 0 0 0 .707l1.412 1.413a.5.5 0 0 0 .708 0l7.964-7.965.005-.004a.525.525 0 0 0 .032-.03l3.003-3.003a.5.5 0 0 0 0-.707l-1.414-1.415ZM10.5 4c0 .834.667 1.5 1.5 1.5-.833 0-1.5.667-1.5 1.5 0-.833-.667-1.5-1.5-1.5.833 0 1.5-.666 1.5-1.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconMagicWandStyle0; }
}, [1, "cosmos-icon-magic-wand", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-magic-wand"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-magic-wand":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMagicWand$1);
            }
            break;
    } });
}

const CosmosIconMagicWand = CosmosIconMagicWand$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMagicWand, defineCustomElement };
